// Visual tokens for the payment notice system. Mirrors the soft
// pastel-background + soft-border + dark-text formula already used by
// StockInconsistencyBanner (violet), extended with amber (preventive)
// and red (critical/blocked) variants so all three states read as one
// system with increasing urgency. `accent` is the 4px left edge; the colour
// only signals severity, the icon and the title text carry the meaning too.
export const PAYMENT_BANNER_VARIANTS = {
  warning: {
    background: '#FFFBEB',
    border: '#FDE68A',
    accent: '#F59E0B',
    iconBackground: '#FEF3C7',
    iconColor: '#B45309',
    titleColor: '#92400E',
    icon: 'warning circle',
  },
  critical: {
    background: '#FEF2F2',
    border: '#FECACA',
    accent: '#DC2626',
    iconBackground: '#FEE2E2',
    iconColor: '#DC2626',
    titleColor: '#991B1B',
    icon: 'exclamation triangle',
  },
};

// An overdue payment reads like the critical state (it is, in practice, the next step).
PAYMENT_BANNER_VARIANTS.overdue = PAYMENT_BANNER_VARIANTS.critical;

export const PAYMENT_PRIMARY_COLOR = 'violet';

export const PAYMENT_BLOCKED_COLORS = {
  iconBackground: '#FEF2F2',
  iconColor: '#DC2626',
  titleColor: '#111827',
  textColor: '#4B5563',
};
